/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earn_Accumulator_Page_Meta_DescriptionInputs */

const en_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const de_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const pt_br2_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const tr_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const zh_cn2_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const zh_hk2_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const ko_kr2_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const ru_ru2_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

const es_419_earn_accumulator_page_meta_description = /** @type {(inputs: Earn_Accumulator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target below today’s market and earn variable returns while your order waits.`)
};

/**
* | output |
* | --- |
* | "Set a target below today’s market and earn variable returns while your order waits." |
*
* @param {Earn_Accumulator_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const earn_accumulator_page_meta_description = /** @type {((inputs?: Earn_Accumulator_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earn_Accumulator_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earn_accumulator_page_meta_description(inputs)
	if (locale === "de") return de_earn_accumulator_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_earn_accumulator_page_meta_description(inputs)
	if (locale === "tr") return tr_earn_accumulator_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_earn_accumulator_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_earn_accumulator_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_earn_accumulator_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_earn_accumulator_page_meta_description(inputs)
	return es_419_earn_accumulator_page_meta_description(inputs)
});